<template>
  <picture>
    <client-only v-if="useWebp">
      <source :srcset="webpImageUrl" type="image/webp" />
      <source :srcset="baseImageUrl" :type="srcMime" />
    </client-only>
    <img :src="baseImageUrl" :class="classes" :alt="alt" :style="styles" :loading="loading" />
  </picture>
</template>

<script>
/* istanbul ignore file */
// ONLY USE THIS FOR ASSET WITH .EXTENSION.WEBP
import { assetURL, imageryURL, getMime } from 'shared/helpers/assetHelper';
import ClientOnly from 'vue-client-only';

export default {
  name: 'NewWebpImageContainer',
  components: {
    ClientOnly,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'original',
    },
    alt: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
    styles: {
      type: String,
      default: '',
    },
    isExternal: {
      type: Boolean,
      default: false,
    },
    isImagery: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: String,
      default: 'auto',
    },
    isSsr: {
      type: Boolean,
      default: false,
    },
    useWebp: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    srcMime() {
      return getMime(this.src);
    },

    webpImageUrl() {
      return this.loaderUrl(`${this.src}.webp`);
    },

    baseImageUrl() {
      return this.loaderUrl(this.src);
    },
  },
  methods: {
    loaderUrl(src) {
      const imgSrc = this.isImagery ? imageryURL(src, this.size) : src;
      return this.isExternal ? imgSrc : assetURL(imgSrc, this.isSsr);
    },
  },
};
</script>
